module.exports = __webpack_public_path__ + "static/media/fWilson.7c0da4ca.jpeg";